<template>
    <div class="scraped-data-container">
        <h2 class="page-title">采集数据列表</h2>
        <!-- 过滤区域 -->
        <div class="filter-container">
            <el-input v-model="searchQuery" placeholder="搜索标题或摘要" clearable @input="fetchData" style="width: 200px;" />
            <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :clearable="true"
                :unlink-panels="true" :teleported="false" style="width: 250px;" />
            <el-button type="primary" @click="fetchData">确认</el-button>
        </div>

        <!-- 采集数据列表 -->
        <el-table :data="dataList" border style="width: 100%">
            <el-table-column prop="zhTitle" label="标题" class="text-ellipsis">
                <template #default="scope">
                    <el-tooltip effect="dark" placement="top">
                        <template #content>
                            <div class="tooltip-content">
                                {{ scope.row.zhTitle || '--' }}
                            </div>
                        </template>
                        <span class="ellipsis">
                            {{ scope.row.zhTitle || '--' }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="taskTitle" label="来源" >
                <template #default="scope">
                    <el-tooltip effect="dark" placement="top">
                        <template #content>
                            <div class="tooltip-content">
                                {{ scope.row.taskTitle || '--' }}
                            </div>
                        </template>
                        <span class="ellipsis">
                            {{ scope.row.taskTitle || '--' }}
                        </span>
                    </el-tooltip>
                </template>

                </el-table-column>
            <el-table-column prop="abstracts" label="摘要" >
                <template #default="scope">
                    <el-tooltip effect="dark" placement="top">
                        <template #content>
                            <div class="tooltip-content">
                                {{ scope.row.abstracts || '--' }}
                            </div>
                        </template>
                        <span class="ellipsis">
                            {{ scope.row.abstracts || '--' }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="country" label="国家"  />
            <el-table-column prop="langName" label="语言" />
            <el-table-column prop="publishTime" label="发布时间"  sortable />
            <el-table-column prop="runTime" label="采集时间"  sortable />
            <el-table-column prop="url" label="链接">
                <template #default="{ row }">
                    <a :href="row.url" target="_blank">查看</a>
                </template>
            </el-table-column>
        </el-table>

        <!-- 底部分页 -->
        <div class="footer-container">
            <div class="total-items">共: {{ totalItems }} 条数据</div>
            <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :total="totalItems"
                layout="prev, pager, next, jumper" @current-change="fetchData" @size-change="fetchData" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";

const dataList = ref([]);
const searchQuery = ref("");
const timeRange = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalItems = ref(0);
const itemsPerPage = ref(10);

const fetchData = async () => {
    const response = await axios.get("http://127.0.0.1:8000/api/database/scrape", {
        params: {
            page: currentPage.value,
            pagesize: pageSize.value,
            search: searchQuery.value,
            start_date: timeRange.value ? timeRange.value[0] : "",
            end_date: timeRange.value ? timeRange.value[1] : "",
        },
    });

    dataList.value = response.data.data;
    totalItems.value = response.data.total_count;
};

onMounted(fetchData);
</script>

<style scoped>
.scraped-data-container {
    padding: 20px;
    width: 95%;
}

.filter-container {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
}

.footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.total-items {
    height: 40px;
    font-size: 14px;
    color: #666;
}

/* 加在 <style scoped> 或全局样式里 */
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
}

.tooltip-content {
    max-width: 400px;
    white-space: normal;
    word-break: break-word;
}

/* 设置 el-table 的行高 */
.el-table .el-table__row {
  height: 40px;
}
.el-table .el-table__cell {
  line-height: 40px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>